/**
 * Вспомогательная функция для склонения русских слов
 */
const getPluralForm = (count, one, few, many) => {
    const mod10 = count % 10
    const mod100 = count % 100

    if (mod10 === 1 && mod100 !== 11) return one
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few
    return many
}

const actionTexts = {
    add: {
        feminine: 'добавлена',
        neutral: 'добавлено',
        plural: 'добавлены',
        preposition: 'в',
        stopList: 'стоп-лист',
        fallback: 'Позиции добавлены в стоп-лист',
    },
    remove: {
        feminine: 'снята',
        neutral: 'снято',
        plural: 'сняты',
        preposition: 'со',
        stopList: 'стоп-листа',
        fallback: 'Позиции сняты со стоп-листа',
    },
}

/**
 * Генерирует текст успешного уведомления для операций со стоп-листом
 */
export const getSuccessText = (categories, menuItems, action = 'add') => {
    const categoriesCount = categories?.length || 0
    const menuItemsCount = menuItems?.length || 0
    const actionText = actionTexts[action] || actionTexts.add

    // СЛУЧАЙ 0: Пустые данные
    if (categoriesCount === 0 && menuItemsCount === 0) {
        return actionText.fallback
    }

    // СЛУЧАЙ 1: Ровно 1 категория И 0 блюд
    if (categoriesCount === 1 && menuItemsCount === 0) {
        const item = categories[0]
        return `Категория «${item.name}» ${actionText.feminine} ${actionText.preposition} ${actionText.stopList}`
    }

    // СЛУЧАЙ 2: 0 категорий И ровно 1 блюдо
    if (categoriesCount === 0 && menuItemsCount === 1) {
        const item = menuItems[0]
        return `Блюдо «${item.name}» ${actionText.neutral} ${actionText.preposition} ${actionText.stopList}`
    }

    // СЛУЧАЙ 3: 0 категорий И несколько блюд
    if (categoriesCount === 0 && menuItemsCount > 1) {
        const pluralForm = getPluralForm(
            menuItemsCount,
            'блюдо',
            'блюда',
            'блюд'
        )
        return `${menuItemsCount} ${pluralForm} ${actionText.plural} ${actionText.preposition} ${actionText.stopList}`
    }

    // СЛУЧАЙ 4: Несколько категорий И есть блюда (смешанный)
    return actionText.fallback
}
